export default [
  {
    id: "micro01",
    animationPosition: { top: "45.9", left: "45.6" },
    width: "12.35",
    height: "auto",
    animation: "SmartLights.json",
    ref: "smartLights",
    buttonId: "micro01Button",
    buttonDelay: 8000,
    position: { top: "49", left: "51" },
    arrowPosition: "center",
    text:
      "Smart lights reduce energy consumption by turning on only when citizens are walking on the path."
  },
  {
    id: "micro02",
    animationPosition: { top: "59.7", left: "13" },
    width: "9.5",
    height: "auto",
    animation: "solar-glow-for-Marina-building.json ",
    ref: "solarPanels",
    buttonId: "micro02Button",
    buttonDelay: 8000,
    position: { top: "60.5", left: "17" },
    arrowPosition: "left",
    text:
      "Solar panels make self-sustaining energy, so less energy is needed from utilities."
  },
  {
    id: "micro03",
    animationPosition: { top: "46.7", left: "35.8" },
    width: "4.5",
    height: "auto",
    animation: "cctv.json",
    ref: "cctv",
    buttonId: "micro03Button",
    buttonDelay: 8000,
    position: { top: "48", left: "37.5" },
    arrowPosition: "center",
    text:
      "Dell Technologies IoT Solution for Surveillance reduces fraudulent activity by constantly monitoring the ATM."
  },
  {
    id: "micro04",
    animationPosition: { top: "35", left: "94.5" },
    width: "2",
    height: "auto",
    animation: "WaterQualityUI.json",
    ref: "smoke",
    buttonId: "micro04Button",
    buttonDelay: 8000,
    position: { top: "35", left: "95" },
    arrowPosition: "right",
    text:
      "Air sensors help keep employees safe by constantly monitoring the quality of the air."
  },
  {
    id: "micro05",
    animationPosition: { top: "64.5", left: "54.3" },
    width: "2",
    height: "auto",
    animation: "WaterQualityUI.json",
    ref: "water",
    buttonId: "micro05Button",
    buttonDelay: 8000,
    position: { top: "65.5", left: "54.2" },
    arrowPosition: "right",
    text:
      "Water quality is analyzed in the cloud to keep citizens and environments safe."
  },
  {
    id: "micro06",
    animationPosition: { top: "61.3", left: "58.75" },
    width: "7.3",
    height: "auto",
    animation: "Cars_Charging.json",
    ref: "charging",
    buttonId: "micro06Button",
    buttonDelay: 8000,
    position: { top: "61.8", left: "63.75" },
    arrowPosition: "center",
    text:
      "Cars are wirelessly charged to Proactive Maintenance and consume energy more efficiently."
  }
];
